import { useEffect, useState } from 'react'
import useCart from '@components/orders/hooks/useCart'
import Cookie from 'js-cookie'
import { usePathname, useSearchParams } from 'next/navigation'
import { removeQueryParams } from '@utils/utilities'

export default function useSharedCart({ cartHash, openCart }) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const { createCart } = useCart()
  const [loadingSharedCart, setLoadingSharedCart] = useState<boolean>(false)

  useEffect(() => {
    const getLineItems = async (cartHash) => {
      try {
        setLoadingSharedCart(true)

        const items = await (
          await fetch(
            `/api/bigcommerce/adminCart/getSharedCartItems?configId=${cartHash}`
          )
        ).json()

        if (items) {
          const parsedItems = items.map((x) => ({
            quantity: +x.quantity,
            variant_id: +x.variantId,
            product_id: +x.productId,
            option_selections: x?.options?.map((option) => ({
              option_id: +option.nameId,
              option_value: option.valueId
                ? String(option.valueId)
                : JSON.stringify(option?.value),
            })),
          }))

          const cartResponse = await createCart({
            lineItems: parsedItems,
          })

          Cookie.set('bc_cartId', cartResponse?.cart?.id)
          openCart()

          removeQueryParams({
            path: pathname,
            query: searchParams.toString(),
            paramNames: ['cartHash', 'slug'],
          })
        }
      } finally {
        setLoadingSharedCart(false)
      }
    }

    if (cartHash) {
      getLineItems(cartHash)
    }
  }, [cartHash])

  return {
    loadingSharedCart,
  }
}
